/* eslint-disable arrow-body-style */
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import {
  Box, Button, Typography,
} from '@mui/material';

const HomeBannerMobileTemplate = ({ banner }) => {
  return (
    <Box
      sx={{
        marginTop: '80px',
        backgroundImage: 'linear-gradient(to bottom, #E60E68, #B3004A)',
        height: 'calc(100vh - 80px)',
        paddingLeft: '30px',
        paddingRight: '30px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <Box>
        <Typography
          sx={{
            color: '#fff',
            fontSize: '28px',
            fontFamily: 'Poppins',
            fontWeight: '700',
            paddingTop: '14px',
            marginBottom: '8px',
          }}
        >
          {parse(banner.title)}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <img
            src={banner.image}
            alt=""
            style={{
              width: '90%',
              objectFit: 'contain',
            }}
          />
        </Box>
        <Typography
          sx={{
            color: '#fff',
            fontSize: '24px',
            fontFamily: 'Poppins',
            paddingTop: '14px',
            marginBottom: '8px',
          }}
        >
          {parse(banner.description)}
        </Typography>
      </Box>
      <Box sx={{ marginBottom: '50px' }}>
        <Button
          fullWidth
          variant="contained"
          color="white"
          sx={{ width: '352px' }}
          onClick={() => window.open(banner.link, '_blank')}
        >
          {banner.ctaLabel}
        </Button>
      </Box>
    </Box>
  );
};

HomeBannerMobileTemplate.propTypes = {
  banner: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default HomeBannerMobileTemplate;
